import { useEffect, useState } from "react";
import { getScripts, type ScriptInfo } from "../net/api";

export type ScriptLoad = ScriptInfo | "loading" | "error";
export type ScriptsLoad = ScriptInfo[] | "loading" | "error";

/** Every script's catalog from the server, in the order the lobby offers them. */
export function useScripts(): ScriptsLoad {
  const [scripts, setScripts] = useState<ScriptsLoad>("loading");
  useEffect(() => {
    let live = true;
    getScripts()
      .then((list) => live && setScripts(list))
      .catch(() => live && setScripts("error"));
    return () => {
      live = false;
    };
  }, []);
  return scripts;
}

/** One script's catalog from the server: the one with this id, or the first if none is given. */
export function useScript(id?: string): ScriptLoad {
  const scripts = useScripts();
  if (scripts === "loading" || scripts === "error") return scripts;
  return (id ? scripts.find((s) => s.id === id) : scripts[0]) ?? "error";
}
